/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

EDC.Games.CountByDragging.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.CountByDragging, 33]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.CountByDragging.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.blocks = [];
  this.dropZoneItems = [];
  this.blockcount = [];
  this.instructionBox = [];
  this.scaleNumber = [];
};

EDC.Games.CountByDragging.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CountByDragging.Scenes.Main.prototype.constructor = EDC.Games.CountByDragging.Scenes.Main;

const CBD = EDC.Games.CountByDragging.Scenes.Main.prototype;

CBD.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

CBD.createTemplateUI = function () {
  this.add.sprite(1025, 405, 'item').setOrigin(0);
  const arrow = this.add
    .sprite(635, 205, 'arrow')
    .setOrigin(0)
    .setScale(0.7);
  this.tweens.add({
    targets: arrow,
    alpha: 0.1,
    duration: 1400,
    ease: 'Linear',
    repeat: -1,
    yoyo: true,
  });

  this.add.sprite(950, 90, 'title');
  this.addTextBlock();
  this.addSubmitButton();
};

CBD.loadIteration = function () {
  this.createBlocks();
  console.log('Difficulty ', this.difficulty);
  console.log('Iteration ', this.iteration);
};

CBD.createBlocks = function () {
  this.BlockCounter();
  this.addInstruction();
  for (let i = 0; i < 6; i++) {
    const blockcont = this.createBlockData(i);
    this.blocks.push(blockcont);
  }
  this.blocksFallAnimation();
};

CBD.blocksFallAnimation = function () {
  for (let i = 0; i < this.blocks.length; i++) {
    this.blocks[i].floatAnim.stop();
    this.blocks[i].y = -300;
    const randomDelay = Math.round(Math.random() * 300);
    this.tweens.add({
      targets: this.blocks[i],
      y: this.blocks[i].init_pos_y,
      duration: 900,
      ease: 'Sine.easeInOut',
      delay: randomDelay,
      onComplete: this.generateDataForFloat.bind(this, this.blocks[i]),
    });
  }
};

CBD.getBlockPosition = function (i) {
  const blockPositions = {
    0: { x: 430, y: 415 },
    1: { x: 590, y: 320 },
    2: { x: 270, y: 320 },
    3: { x: 310, y: 590 },
    4: { x: 625, y: 540 },
    5: { x: 480, y: 675 },
  };
  return blockPositions[i];
};

CBD.generateDataForFloat = function (block) {
  const randomDistance = 10 + Math.round(Math.random() * 10);
  const randomDelay = Math.round(Math.random() * 800);
  const randomTime = 900 + Math.round(Math.random() * 400);
  block.floatAnim = this.tweens.add({
    targets: block,
    y: block.init_pos_y - randomDistance,
    duration: 1200,
    ease: 'Sine.easeInOut',
    repeat: -1,
    delay: randomDelay,
    yoyo: true,
  });
};

CBD.onDragstart = function (dragObj, pointer) {
  this.tweens.killTweensOf(dragObj);
  if (dragObj.x > 1100) {
    const index = this.dropZoneItems.indexOf(dragObj);
    this.dropZoneItems.splice(index, 1);
    this.time.delayedCall(250, this.condenceBlocks, [], this);
    this.blockcount.map((x) => {
      x.destroy();
    });
    this.BlockCounter();
  }
};

CBD.onDragStop = function (dragObj, pointer) {
  if (dragObj.x > 1100 && this.dropZoneItems.length < 10) {
    if (!dragObj.replaced) {
      this.replaceInitialBlock(dragObj);
    }
    dragObj.setScale(0.8);
    this.addBlockOnDropZone(dragObj);
    this.dropZoneItems.push(dragObj);
    this.blockcount.map((x) => {
      x.destroy();
    });
    this.BlockCounter();
  } else if (this.dropZoneItems.length === 10) {
    this.releaseBlock(dragObj);
  } else {
    dragObj.replaced ? this.removeBlock(dragObj) : this.releaseBlock(dragObj);
  }
};

CBD.removeBlock = function (dragObj) {
  this.tweens.add({
    targets: dragObj,
    x: dragObj.init_pos_x,
    y: dragObj.init_pos_y,
    duration: 200,
    ease: 'Quint.easeOut',
    onComplete() {
      dragObj.destroy();
    },
  });
};

CBD.addBlockOnDropZone = function (dragObj) {
  const { x, y } = this.getDropZonePosition(this.dropZoneItems.length);
  dragObj.x = x;
  dragObj.y = y;
};

CBD.condenceBlocks = function () {
  this.dropZoneItems.map((block, index) => {
    const { x, y } = this.getDropZonePosition(index);
    this.tweens.add({
      targets: block,
      x,
      y,
      duration: 600,
      ease: 'Quint.easeOut',
    });
  });
};

CBD.addSubmitButton = function () {
  const button = this.add.sprite(0, 0, 'button');
  const done = this.add
    .sprite(5, 30, 'done')
    .setScale(0.65)
    .setAlpha(0.8);
  const buttonContainer = this.add.container(1490, 900);
  buttonContainer.add(button);
  buttonContainer.add(done);
  buttonContainer.setSize(300, 300);
  buttonContainer.setInteractive();
  this.cursorManager.setDefaultDraggableEvents(buttonContainer);
  buttonContainer.on('pointerup', this.checkAnswer, this);
};

CBD.addTextBlock = function () {
  const scaleFrame = this.add.sprite(0, 0, 'scale-frame');
  const frameContainer = this.add.container(1485, 760);
  frameContainer.setSize(555, 180);
  const font = {
    align: 'center',
    font: '70px Arial',
    fill: 'white',
    stroke: 'white',
    strokeThickness: 5,
    padding: {
      left: 150,
      right: 0,
      top: 15,
      bottom: 30,
    },
  };
  const textOnScale = this.add.text(0, 0, 'B L O C K S', font).setOrigin(0.5);
  textOnScale.setScale(0.95);
  frameContainer.add(scaleFrame);
  frameContainer.add(textOnScale);
  this.scaleNumber.push(frameContainer);
};

CBD.addInstruction = function () {
  const emptyInstruction = this.add.sprite(550, 900, 'instructions');
  const font = {
    align: 'center',
    font: '80px Arial',
    fill: 'cyan',
    stroke: 'blue',
    strokeThickness: 10,
  };
  const instruction = this.add.text(
    470,
    795,
    this.gameConfig.sets[this.difficulty].iterations[this.iteration].correctAnswer,
    font,
  );
  this.instructionBox.push(instruction);
  this.instructionBox.push(emptyInstruction);
};

CBD.replaceInitialBlock = function (dragObj) {
  dragObj.replaced = true;
  const index = this.blocks.indexOf(dragObj);
  const blockcont = this.createBlockData(index);
  this.blocks[index] = blockcont;
  this.startFlying(blockcont);
};

CBD.releaseBlock = function (dragObj) {
  dragObj.setScale(1);
  this.tweens.add({
    targets: dragObj,
    x: dragObj.init_pos_x,
    y: dragObj.init_pos_y,
    duration: 600,
    ease: 'Quint.easeOut',
    onComplete: this.generateDataForFloat.bind(this, dragObj),
  });
};

CBD.startFlying = function (blockcont) {
  blockcont.x = -500;
  this.tweens.add({
    targets: blockcont,
    x: blockcont.init_pos_x,
    y: blockcont.init_pos_y,
    duration: 600,
    ease: 'Quint.easeOut',
  });
};

CBD.BlockCounter = function () {
  const font = {
    align: 'center',
    font: '110px Arial',
    fill: 'black',
    stroke: 'black',
    strokeThickness: 8,
  };
  const blockCountText = this.difficulty === 1 ? this.dropZoneItems.length : '?';
  const count = this.add.text(1250, 695, blockCountText, font);
  this.blockcount.push(count);
};

CBD.checkAnswer = function () {
  if (this.dropZoneItems.length === this.gameConfig.sets[this.difficulty].iterations[this.iteration].correctAnswer) {
    this.playCorrect();
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    this.playWrong();
    this.changeColor();
    this.time.delayedCall(2000, this.emptyDropZone, [], this);
  }
};

CBD.nextIteration = function () {
  this.dropZoneItems.map((x) => {
    x.destroy();
    return true;
  });
  this.instructionBox.map((x) => {
    x.destroy();
    return true;
  });
  this.blockcount.map((x) => {
    x.destroy();
    return true;
  });
  this.blocks.map((x) => {
    x.destroy();
    return true;
  });
  this.blocks = [];
  this.dropZoneItems = [];
  this.blockcount = [];
  this.instructionBox = [];

  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

CBD.changeColor = function () {
  this.dropZoneItems.map((x) => {
    x.first.setTint(0xff0000);
    return true;
  });
};

CBD.emptyDropZone = function () {
  this.dropZoneItems.map((x) => {
    x.destroy();
    return true;
  });
  this.dropZoneItems = [];
};

CBD.createBlockData = function (index) {
  const { x, y } = this.getBlockPosition(index);
  const blockcont = this.add.container(x, y);
  const block = this.add.sprite(0, 0, 'block');
  block.setScale(1.2);
  blockcont.init_pos_x = x;
  blockcont.init_pos_y = y;
  blockcont.add(block);
  this.generateDataForFloat(blockcont);
  blockcont.setSize(180, 180);
  blockcont.setInteractive();
  this.cursorManager.setDefaultDraggableEvents(blockcont);
  this.input.setDraggable(blockcont);

  blockcont.on(
    'drag',
    ((sprite, pointer, x, y) => {
      sprite.setPosition(x, y);
    }).bind(this, blockcont),
  );

  blockcont.on('dragend', this.onDragStop.bind(this, blockcont), this);
  blockcont.on('dragstart', this.onDragstart.bind(this, blockcont), this);
  return blockcont;
};
CBD.getDropZonePosition = function (i) {
  const blockPositions = {
    0: { x: 1270, y: 460 },
    1: { x: 1420, y: 460 },
    2: { x: 1570, y: 460 },
    3: { x: 1720, y: 460 },
    4: { x: 1340, y: 315 },
    5: { x: 1500, y: 315 },
    6: { x: 1660, y: 315 },
    7: { x: 1420, y: 170 },
    8: { x: 1570, y: 170 },
    9: { x: 1500, y: 50 },
  };
  return blockPositions[i];
};
export default EDC.Games.CountByDragging.Scenes.Main;
